import { render, staticRenderFns } from "./TyhjaTaulukkoOtsikko.vue?vue&type=template&id=49a8c428&"
import script from "./TyhjaTaulukkoOtsikko.vue?vue&type=script&lang=js&"
export * from "./TyhjaTaulukkoOtsikko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a8c428')) {
      api.createRecord('49a8c428', component.options)
    } else {
      api.reload('49a8c428', component.options)
    }
    module.hot.accept("./TyhjaTaulukkoOtsikko.vue?vue&type=template&id=49a8c428&", function () {
      api.rerender('49a8c428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TyhjaTaulukkoOtsikko.vue"
export default component.exports